import { JsonpClientBackend } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BasicAuthentication } from 'src/app/models/module.model';

@Component({
  selector: 'app-api-authentication',
  templateUrl: './api-authentication.component.html',
  styleUrls: ['./api-authentication.component.css']
})
export class ApiAuthenticationComponent implements OnInit {
  public auth: BasicAuthentication;
  public token: string;
  constructor(public dialogRef: MatDialogRef<ApiAuthenticationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    // if(this.data.modalName === "Confirmation")
    // {

    // }else if(this.data.modalName === "BasicAuthentication"){

    // }
  }

  authenticateApi() {
    this.dialogRef.close(this.auth);
  }

  cancelAuthentication() {
    this.dialogRef.close({ result: 'canceled' });
  }

  continue() {
    this.dialogRef.close({ result: 'confirmed' });
  }

  prettify(obj) {
    return JSON.stringify(obj).replace(/[{]/g, '{<br/>').replace(/[}]/g, '}<br/>')
      .replace(/[[]/g, '[<br/>').replace(/[]]/g, ']<br/>').replace(/(,")/g,',<br/>"');
  }

  sendToken(){
    this.dialogRef.close({ token: this.token });
  }

}
